/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import {
    string, node, func,
} from 'prop-types';
import mbpUtil from '@api-util/mbp';
import withScript from '../../../../../../lib/scriptLoader';

const GOOGLE_KEY_PWA = mbpUtil.getEnv('APP_GOOGLE_KEY_PWA') || '';
const GOOGLE_MAPS_SRC_URL = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_KEY_PWA}&libraries=places`;

let componentForm = {
    premise: { get: 'long_name', value: '' },
    street_number: { get: 'short_name', value: '' },
    route: { get: 'long_name', value: '' },
    sublocality_level_2: { get: 'long_name', value: '' },
    sublocality_level_1: { get: 'long_name', value: '' },
    locality: { get: 'long_name', value: '' },
    administrative_area_level_1: { get: 'short_name', value: '' },
    administrative_area_level_2: { get: 'long_name', value: '' },
    country: { get: 'short_name', value: '' },
    postal_code: { get: 'long_name', value: '' },
};

const setFields = [
    'address_components',
    'adr_address',
    'alt_id',
    'formatted_address',
    'geometry',
    'icon',
    'id',
    'name',
    'permanently_closed',
    'photo',
    'place_id',
    'scope',
    'type',
    'url',
    'utc_offset',
    'vicinity',
];

class GoogleAddressSearch extends React.Component {
    constructor(props) {
        super(props);
        this.googleMapLoaded = false;
    }

    componentDidMount() {
        this.initGoogleAutoComplete();
    }

    componentDidUpdate() {
        this.initGoogleAutoComplete();
    }

    initGoogleAutoComplete = () => {
        if (typeof window !== 'undefined' && window.google && !this.googleMapLoaded && window.google.maps && window.google.maps.places && window.google.maps.event) {
            const { searchId } = this.props;
            if (document.getElementById(searchId)) {
                const gAutoComplete = new window.google.maps.places.Autocomplete(
                    (typeof document !== 'undefined') && document.getElementById(searchId),
                    { types: ['address'], componentRestrictions: { country: ['us', 'ca'] }, fields: setFields },
                );
                window.google.maps.event.addListener(gAutoComplete, 'place_changed', () => this.fillInAddress(gAutoComplete));

                this.googleMapLoaded = true;
                document.getElementById(searchId).addEventListener('focus', () => {
                    if (document.getElementById(searchId).getAttribute('autocomplete') !== 'new-password') {
                        document.getElementById(searchId).setAttribute('autocomplete', 'new-password');
                        this.setZIndex();
                    }
                });
            }
        }
    }

    setZIndex = () => {
        const autoCompleteList = document.querySelectorAll('.pac-container');
        autoCompleteList.forEach((item) => {
            const elementAutoComplete = item;
            elementAutoComplete.style.zIndex = '10000';
        });
    }

    fillInAddress(autocomplete) {
        if (window.google) {
            componentForm = {
                premise: { get: 'long_name', value: '' },
                street_number: { get: 'short_name', value: '' },
                route: { get: 'long_name', value: '' },
                sublocality_level_2: { get: 'long_name', value: '' },
                sublocality_level_1: { get: 'long_name', value: '' },
                locality: { get: 'long_name', value: '' },
                administrative_area_level_1: { get: 'short_name', value: '' },
                administrative_area_level_2: { get: 'long_name', value: '' },
                country: { get: 'short_name', value: '' },
                postal_code: { get: 'long_name', value: '' },
            };

            const { place } = autocomplete?.gm_accessors_ || {};
            let addressLineFromPrediction = '';
            let formattedPrediction  = '';

            if (place) {
                Object.keys(place).forEach((key) => {
                    if (!formattedPrediction) {
                        formattedPrediction = place[key].formattedPrediction;
                    }
                });
            }

            if (formattedPrediction) {
                const arrPredictionAddress = formattedPrediction.split(',');
                if (arrPredictionAddress.length > 0) {
                    [addressLineFromPrediction] = arrPredictionAddress;
                }
            }
            const locationDetails = autocomplete.getPlace();
            const addressDetails = locationDetails.address_components;
            const addressLine1 = [];
            const addressLine2 = [];

            addressDetails.forEach((element) => {
                const addressType = element.types[0];
                if (componentForm[addressType]) {
                    const addressLabel = componentForm[addressType].get;
                    const addressValue = element[addressLabel];
                    componentForm[addressType].value = addressValue;
                }
            });

            if (componentForm.premise.value) {
                addressLine1.push(componentForm.premise.value);
            }
            if (componentForm.street_number.value) {
                addressLine1.push(componentForm.street_number.value);
            }
            if (componentForm.route.value) {
                addressLine1.push(componentForm.route.value);
            }

            if (componentForm.sublocality_level_2.value) {
                addressLine2.push(componentForm.sublocality_level_2.value);
            }
            if (componentForm.sublocality_level_1.value && componentForm.locality.value !== '') {
                addressLine2.push(componentForm.sublocality_level_1.value);
            }

            const prefillDetails = {
                addressLine1: addressLine1.join(' '),
                addressLine2: addressLine2.join(' '),
                city: componentForm.locality.value || componentForm.sublocality_level_1.value,
                state: componentForm.administrative_area_level_1.value,
                country: componentForm.country.value,
                zipcode: componentForm.postal_code.value,
            };
            if (prefillDetails.addressLine1 !== addressLineFromPrediction && addressLineFromPrediction !== '') {
                prefillDetails.addressLine1 = addressLineFromPrediction;
            }
            this.provideAddressDetails(prefillDetails);
        }
    }

    provideAddressDetails(data) {
        const { getPreFillAddressDetails } = this.props;
        getPreFillAddressDetails(data);
    }

    render() {
        const { children } = this.props;
        return (
            children
        );
    }
}

GoogleAddressSearch.propTypes = {
    getPreFillAddressDetails: func.isRequired,
    children: node.isRequired,
    searchId: string.isRequired,
};

export default withScript(GOOGLE_MAPS_SRC_URL, false, true)(GoogleAddressSearch);
